export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Final Test',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'Securities Markets, Investment Securities, and Economic Factor',
        chapters: [1],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'lock',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: false
    }, {
        id: 2,
        domain_name: 'Securities and Tax Regulation',
        chapters: [2],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'database-lock',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 3,
        domain_name: 'Opening and Servicing Customer Accounts',
        chapters: [3],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'cloud-lock',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 4,
        domain_name: 'Marketing, Prospecting and Sales Presentations',
        chapters: [4],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'cloud-tags',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 5,
        domain_name: 'Investment Company Securities and Variable Contracts',
        chapters: [5],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'tools',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }, {
        id: 6,
        domain_name: 'Evaluation of Customers',
        chapters: [6],
        exam_weightage: 10,
        show_proficiency: true,
        icon: 'clipboard-list',
        num_questions: 5,
        num_flashcards: 5,
        requires_subscription: true
    }
];

export const QUESTION_VERSION_OF_JSON = 1
